import { render } from "./SystemNotificationManagementSettings.vue?vue&type=template&id=87bd37e4"
import script from "./SystemNotificationManagementSettings.vue?vue&type=script&lang=js"
export * from "./SystemNotificationManagementSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__